/** Maps feature_name constants (matching ProFeatureNames.cs) to human-readable labels. */
export const PRO_FEATURE_LABELS: Record<string, string> = {
    SendCaseFile: 'Case File Sharing',
    CopyReceivedCase: 'Copy Received Case',
    SendExpenseLinkToClient: 'Send Expense Links to Clients',
    TeamLogoAndAccent: 'Firm-Branded Documents',
    HighIncomeEstimatePdf: 'High-Income Estimate PDF',
    CalculonAllocationAdvicePdf: 'Allocation Analysis PDF',
    CalculonChatBot: 'Calculon AI Assistant',
    SplitCustody: 'Split Custody Calculations',
    ExpenseTemplates: 'Monthly Expense Templates',
    DivisionExclusions: 'Clear Division Allocations',
    HighIncomeEstimator: 'High-Income Estimator',
    WordDocumentDownload: 'Word Document Downloads',
    EqualizeWithProperty: 'Equalize with Property',
    AlimonyAnalysis: 'Alimony Analysis',
};

export function proFeatureLabel(featureName?: string | null): string {
    if (!featureName) return 'Unknown Feature';
    return PRO_FEATURE_LABELS[featureName] ?? featureName;
}

/** All known feature names (mirrors ProFeatureNames.All in C#). */
export const ALL_PRO_FEATURE_NAMES = Object.keys(PRO_FEATURE_LABELS);

/** Maps pro feature keys to their corresponding feature flag names. Features not in this map have no flag and are always shown. */
export const PRO_FEATURE_FLAG_MAP: Record<string, string> = {
    SendCaseFile: 'SendCaseEnabled',
    CopyReceivedCase: 'SendCaseEnabled',
    SendExpenseLinkToClient: 'SendClientExpenses',
    HighIncomeEstimatePdf: 'HighIncomePdf',
    CalculonAllocationAdvicePdf: 'CalculonAllocationAdvice',
    CalculonChatBot: 'CalculonChatBot',
    SplitCustody: 'SplitCustody',
    DivisionExclusions: 'ClearAllAllocations',
    HighIncomeEstimator: 'HighIncomeEstimator',
    WordDocumentDownload: 'WordDocumentSupport',
    EqualizeWithProperty: 'EqualizeAutomatically',
    AlimonyAnalysis: 'Alimony',
};
